import {UserRecordsFilter} from '../pages/user-management/models';

export const mapBulkUserRowToEditPayload = (rowData: any) => {
  const ipAddress = rowData?.limitIpAddress
    ? rowData.limitIpAddress.split(',')
    : [];
  const isLimitIp = ipAddress.length > 0 && ipAddress[0] !== '';

  return {
    firstName: rowData.firstName,
    lastName: rowData.lastName,
    email: rowData.emailAddress,
    isBillable: rowData.billable,
    isLimitIp,
    ipAddressList: ipAddress,
    role: rowData.userRole != null ? rowData.userRole.roleId : '',
    clientPermissionGroup:
      rowData.clientPermissionGroup?.length > 0
        ? (rowData.clientPermissionGroup?.[0]?.permissionGroupId ?? '')
        : '',
    projectPermissionGroup:
      rowData.projectPermissionGroup?.length > 1
        ? (rowData.projectPermissionGroup?.[1]?.permissionGroupId ?? '')
        : (rowData.projectPermissionGroup?.[0]?.permissionGroupId ?? ''),
    project:
      rowData?.projects?.length > 0 ? rowData.projects[0].projectId : '',
    userImportTempId: rowData.userImportTempId,
    workspace: rowData?.projects?.[0]?.workspaces?.[0]?.workspaceId ?? '',
  };
};

export const openBulkUserRowForEdit = (
  rowData: any,
  filterType: UserRecordsFilter,
  dispatch: (action: any) => void,
  actions: {
    setDrawer: (open: boolean) => any;
    setErrors: (errors: unknown[]) => any;
    setBulkUserEdit: (data: ReturnType<typeof mapBulkUserRowToEditPayload>) => any;
    setTab: (tab: UserRecordsFilter) => any;
    setDismissbanner: (show: boolean) => any;
  }
) => {
  dispatch(actions.setDrawer(true));
  if (filterType === UserRecordsFilter.USER_RECORDS_WITH_NO_ERROR) {
    return;
  }

  dispatch(actions.setErrors(rowData.errors ?? []));
  dispatch(actions.setBulkUserEdit(mapBulkUserRowToEditPayload(rowData)));
  dispatch(actions.setTab(filterType));
  if (filterType === UserRecordsFilter.USER_RECORDS_WITH_ERROR) {
    dispatch(actions.setDismissbanner(true));
  } else {
    dispatch(actions.setDismissbanner(false));
  }
};
